import {Panes, TextField} from '@management-ui/core';
import React from 'react';

const Fields = ({material = {}, prefix = ''}) => {
  return (
    <Panes
      entity={material}
      prefix={prefix}
      panes={[
        {
          title: 'Material Details',
          fields: [
            <TextField
              name="name"
              prefix={prefix}
              label="Name"
              rules={{required: 'Please enter a name'}}
            />,
          ]
        }
      ]}
      title=""/>
  );
};

export default Fields;
